<template>
  <div class="landingContentDivPayment">
    <main>
      <payment-modal></payment-modal>
    </main>
  </div>
</template>

<script>
  import DirectLinkModal from '@/components/modals/provider/DirectLinkModal.vue'
  import ProviderLink from '@/components/providerLink/ProviderLink.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import HomeFooter from '@/components/home/HomeFooter.vue'
  import PaymentModal from '@/components/modals/PaymentModal.vue'
  
  export default {
    name: 'paymentsMK',
    components: {
      ProviderLink,
      DirectLinkModal,
      FontAwesomeIcon,
      HomeFooter,
      PaymentModal
    },
    mounted () {
      this.$modal.show('payment-modal', {paymentUrl: '/payment/subscribe/'})
    }
  }
</script>

<style lang="scss">
  @import '~@/variables.scss';

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Bold.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.svg#TitilliumWeb-Bold') format('svg');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Regular.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.svg#TitilliumWeb-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Humnst777-Blk-BT-Black-Italic';
    src: url('~@/assets/fonts/Humnst777-Blk-BT-Black-Italic.ttf') format('truetype');
  }

  .landingContentDivPayment{
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #aaa;
    background-color: #393839;
    height: calc(100vh - 3em - 58px);
  }
</style>



// WEBPACK FOOTER //
// src/components/paymentsMK/PaymentsMK.vue